import { useEffect } from 'react';
import Hls from 'hls.js';

export function useVideoPlayer(videoRef, hlsStreamUrl, isOnLive) {
  useEffect(() => {
    if (!hlsStreamUrl || !videoRef.current) return;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(hlsStreamUrl);
      hls.attachMedia(videoRef.current);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoRef.current?.play().catch((err) => console.warn('Auto play blocked:', err));
      });
      // Cleanup HLS instance on unmount
      return () => {
        hls.destroy();
      };
    } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
      videoRef.current.src = hlsStreamUrl;
      videoRef.current.play().catch((err) => console.warn('Auto play blocked:', err));
    }
  }, [videoRef, hlsStreamUrl, isOnLive]);
}
